import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import * as css from './styles.css'
import { StandardListViewProductInfo } from '@components/UI-Components/StandardListViewProductInfo'
import { StandardAttributeList } from '@components/UI-Components/StandardAttributeList'
import { StandardTableView } from '@components/UI-Components/StandardTableView/container'
import { productOrderTableDefService } from '../services/ProductOrderTableDefinitionService'

export interface ProductInfoProps {
  product: any
  productOrderTotals: any
  hasRetailChannel: boolean
  hasWholesaleChannel: boolean
}

const HEADERHEIGHT = 32
const ROWHEIGHT = 30
const CHANNELTABLEROWHEIGHT = 16
const CHANNELTABLEHEADERHEIGHT = 24

export const ProductInfo: FC<ProductInfoProps> = ({
  product,
  productOrderTotals,
  hasRetailChannel,
  hasWholesaleChannel
}) =>
  useObserver(function useHook() {
    const selectionTotalColDef =
      productOrderTableDefService.buildColDefinitionForSelectionTotal()
    const reatilTotalColDef =
      productOrderTableDefService.buildColDefinitionForRetailTotal()
    const wholesaleTotalColDef =
      productOrderTableDefService.buildColDefinitionForWholesaleTotal()

    return (
      <div className={css.productInfoWrapper}>
        {/* Product Info */}
        <div className={css.productInfo}>
          <StandardListViewProductInfo
            image={product?.imageURL}
            fitStyle={product?.imageURL ? null : 'cover'}
            status={''}
            isActive={product?.isActive}
            isCore={product?.isCore}
          />
          <StandardAttributeList productAttributes={product?.productAttributes} />
        </div>
        {/* Order Totals */}
        <div className={css.orderTotalWrapper}>
          <StandardTableView
            hideLetterNavigation={true}
            colDef={selectionTotalColDef}
            data={productOrderTotals?.OrderSummary || []}
            showBodyRowBorder={false}
            headerHeight={HEADERHEIGHT}
            rowHeight={ROWHEIGHT}
            hideHeaderTopBorder={true}
          />
        </div>
        <div className={css.channelTotalWrapper}>
          {hasRetailChannel && (
            <div className={css.retailTotal}>
              {/* Retail Totals */}
              <StandardTableView
                hideLetterNavigation={true}
                colDef={reatilTotalColDef}
                data={productOrderTotals?.RetailTotals || []}
                showBodyRowBorder={false}
                headerHeight={CHANNELTABLEHEADERHEIGHT}
                rowHeight={CHANNELTABLEROWHEIGHT}
                hideHeaderTopBorder={true}
              />
            </div>
          )}
          {hasWholesaleChannel && (
            <div
              className={css.wholesaleTotal}
              style={{ marginTop: hasRetailChannel ? 16 : 0 }}
            >
              {/* Wholesale Totals */}
              <StandardTableView
                hideLetterNavigation={true}
                colDef={wholesaleTotalColDef}
                data={productOrderTotals?.WholesaleTotals || []}
                showBodyRowBorder={false}
                headerHeight={CHANNELTABLEHEADERHEIGHT}
                rowHeight={CHANNELTABLEROWHEIGHT}
                hideHeaderTopBorder={true}
              />
            </div>
          )}
        </div>
      </div>
    )
  })
